module.exports = __webpack_public_path__ + "img/settings-01.343ed071.svg";